import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Helper to get auth config with token from localStorage
const getAuthConfig = () => {
  const token = localStorage.getItem('session_token');
  return {
    withCredentials: true,
    headers: token ? { 'Authorization': `Bearer ${token}` } : {}
  };
};

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Skip auth check if user data passed via location state AND we have a token
    const token = localStorage.getItem('session_token');
    if (location.state?.user && token) {
      setUser(location.state.user);
      setIsAuthenticated(true);
      return;
    }

    // If no token in localStorage, redirect to login immediately
    if (!token) {
      setIsAuthenticated(false);
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/auth/me`, getAuthConfig());
        setUser(response.data);
        setIsAuthenticated(true);
      } catch (error) {
        // Clear invalid token
        localStorage.removeItem('session_token');
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, [location.state]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-amber-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-900 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}